import { Box, Flex } from "@chakra-ui/react";
import DetailsShow from "./DetailsShow";

function AiWebSearch() {
  return (
    <Flex
      h="81vh"
      w="100%"
      justifyContent="space-between"
      align="flex-start"
      direction="column"
    >
      <Box w="100%" flex={1} minH={0}>
        <DetailsShow />
      </Box>
    </Flex>
  );
}

export default AiWebSearch;
